import getCurrentComponent from './getCurrentComponent';
import renderIrisWrapper from './renderIrisWrapper';

export default (
    oneComponent,
    index,
    irisCompleteComponentList,
    irisComponentsWithoutGrid,
    propsData,
    limitInitialComponentsRendered = null
) => {
    let customComponent = null;
    let componentDom = null;
    try {
        /* istanbul ignore else */
        customComponent = getCurrentComponent(oneComponent, index, irisCompleteComponentList);
        /* istanbul ignore else */
        if (customComponent) {
            componentDom = renderIrisWrapper(
                customComponent.component,
                customComponent.props,
                customComponent.index,
                irisComponentsWithoutGrid,
                propsData,
                limitInitialComponentsRendered
            );
        } else {
            console.warn(
                'IRIS: Component name is not there in the export list',
                oneComponent.componentType
            );
        }
    } catch (e) {
        console.warn('IRIS: component name missmatch, check Iris Response');
    }
    return componentDom;
};
